type Props = {
  checked: boolean;
  onChange: (value: boolean) => void;
  label: string;
  description?: string;
};

/** Aan/uit-schakelaar met label en uitleg. Een echte switch voor schermlezers. */
export function Toggle({
  checked,
  onChange,
  label,
  description
}: Props) {
  return <button type="button" role="switch"
  // Nooit zonder waarde: een ontbrekende instelling telt als uit.
  aria-checked={checked === true} onClick={() => onChange(checked !== true)} className="group flex w-full items-start gap-3 rounded-md py-1.5 text-left" data-id="element-5309" data-mp="m7fkufrt2g94">
      <span aria-hidden="true" className={`relative mt-0.5 inline-flex h-5 w-9 shrink-0 rounded-full transition-colors duration-150 ease-soft ${checked === true ? 'bg-clay' : 'bg-line group-hover:bg-ink/20'}`} data-id="element-5310" data-mp="3lmkfxeueyp39">
        <span className={`absolute top-0.5 h-4 w-4 rounded-full bg-white shadow-sm transition-transform duration-150 ease-soft ${checked === true ? 'translate-x-[18px]' : 'translate-x-0.5'}`} data-id="element-5311" data-mp="36ypk3pl404ly" />
      </span>
      <span data-id="element-5312" data-mp="3uj8in0gu18hz">
        <span className="block text-[14px] text-ink" data-id="element-5313" data-mp="3erxu5c5fboe">{label}</span>
        {description && <span className="mt-0.5 block text-[12px] leading-snug text-muted" data-id="element-5314" data-mp="3cf7p4w8lv09">{description}</span>}
      </span>
    </button>;
}